import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  // ButtonGroup,
  Input,
  Container,
  Label,
  Row,
  Col,
  CustomInput,
} from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import * as CONSTANTS from '../constants'
import SearchIcon from "../../../static/images/search_icon.svg"

export const AddProjectForecast = class extends React.PureComponent {
  state={ tempSearch: '', searchAddProject: '' }

  handleChangeSearch = (e) => {
    this.setState({ searchAddProject: e })
  }

  render() {
    const { /* clickRadioAddProject, */handleCheckboxAddProject, clickAddProject,
      toggle, handleClickAll, handleClickNone } = this.props
    const { selectedRadioAddProject, open, selectedProject, projectAdditionalList } = this.props
    const filteredProjects = projectAdditionalList.filter(project => {
      const search = this.state.searchAddProject.toLowerCase()
      const project_code = get(project, 'project_code', '').toLowerCase()
      const project_name = get(project, 'name', '').toLowerCase()
      const project_type = get(project, 'project_type', '')
      if (selectedRadioAddProject === 2) {
        return (
          CONSTANTS.forecast_type.includes(project_type) &&
          (project_code.includes(search) || project_name.includes(search))
        )
      } else if (selectedRadioAddProject === 3) {
        return (
          CONSTANTS.non_chargeable.includes(project_type) &&
          (project_code.includes(search) || project_name.includes(search))
        )
      }
      return project_code.includes(search) || project_name.includes(search)
    })

    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => {
          this.setState({ searchAddProject: '' })
          toggle('cancel')
        } }
      >
        <ModalHeader toggle={ () => {
          this.setState({ searchAddProject: '' })
          toggle('cancel')
        } }
        >
          <HeadLabel>{ `Add Project for Forecast & Non-Chargeable` }</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              {/* <TypeButtonGroup>
                <TypeButton
                  color="primary"
                  style={ {
                    backgroundColor: (selectedRadioAddProject === 1) ? '#AD2624' : '#FFFFFF',
                    color: (selectedRadioAddProject === 1) ? '#FFFFFF' : '#D44B49',
                    border: '1px solid #AD2624',
                  } }
                  onClick={ () => clickRadioAddProject(1) }
                  active={ selectedRadioAddProject === 1 }
                >All
                </TypeButton>
                <TypeButton
                  color="primary"
                  style={ {
                    backgroundColor: (selectedRadioAddProject === 2) ? '#AD2624' : '#FFFFFF',
                    color: (selectedRadioAddProject === 2) ? '#FFFFFF' : '#D44B49',
                    border: '1px solid #AD2624',
                  } }
                  onClick={ () => clickRadioAddProject(2) }
                  active={ selectedRadioAddProject === 2 }
                >Forecast
                </TypeButton>
                <TypeButton
                  color="primary"
                  style={ {
                    backgroundColor: (selectedRadioAddProject === 3) ? '#AD2624' : '#FFFFFF',
                    color: (selectedRadioAddProject === 3) ? '#FFFFFF' : '#D44B49',
                    border: '1px solid #AD2624',
                  } }
                  onClick={ () => clickRadioAddProject(3) }
                  active={ selectedRadioAddProject === 3 }
                >Non-Charge
                </TypeButton>
              </TypeButtonGroup> */}
              <TextGroup>
                <TextGroup>Select&nbsp;
                  <ClickableText
                    onClick={ () => handleClickAll(filteredProjects) }
                  >All</ClickableText>
                  &nbsp;/&nbsp;
                  <ClickableText
                    onClick={ () => handleClickNone(filteredProjects) }
                  >None</ClickableText>
                </TextGroup>&nbsp;
                <TextGroup>&nbsp;{`(Selected ${get(this.props, 'selectedProject.length', 0)})`}</TextGroup>&nbsp;
              </TextGroup>
              <SearchField
                placeholder='Search by project code or name'
                onChange={ (e) => {
                  if (e.target.value === '') this.handleChangeSearch(e.target.value)
                  this.setState({ tempSearch: e.target.value })
                } }
                onKeyDown={ (e) => {
                  if (e.keyCode === 13) this.handleChangeSearch(e.target.value)
                } }
              />
              <CheckboxGroup>
                <Row>
                  <Col>
                    { filteredProjects.map(project => {
                      return (
                        <CustomInput
                          key={ project._id }
                          id={ project._id }
                          name='checkboxAddProject'
                          type='checkbox'
                          label={ `${get(project, 'project_code', '')} - ${get(project, 'name', '')}` }
                          onChange={ (e) => handleCheckboxAddProject(e) }
                          checked={ selectedProject.includes(project._id) }
                          // value={ this.state.searchAddProject }
                        />
                      )
                    }) }
                  </Col>
                </Row>
              </CheckboxGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <FooterButton
            bgColor='#AD2624'
            onClick={ () => {
              this.setState({ searchAddProject: '' })
              clickAddProject('add')
            } }
          >Apply
          </FooterButton>
          <FooterButton
            bgColor='white'
            textColor='black'
            onClick={ () => {
              this.setState({ searchAddProject: '' })
              clickAddProject('cancel')
            } }
          >Cancel
          </FooterButton>
        </ModalFooter>
      </Modal>
    )
  }
}

AddProjectForecast.propTypes = {
  open: PropTypes.bool,
  projectAdditionalList: PropTypes.array,
  // clickRadioAddProject: PropTypes.func,
  handleCheckboxAddProject: PropTypes.func,
  clickAddProject: PropTypes.func,
  toggle: PropTypes.func,
  selectedRadioAddProject: PropTypes.number,
  selectedProject: PropTypes.array,
  handleClickAll: PropTypes.func,
  handleClickNone: PropTypes.func,
}
AddProjectForecast.defaultProps = {
  open: false,
  projectAdditionalList: [],
  selectedProject: [],
  selectedRadioAddProject: 1,
  // clickRadioAddProject: () => {},
  handleCheckboxAddProject: () => {},
  clickAddProject: () => {},
  toggle: () => {},
  handleClickAll: () => {},
  handleClickNone: () => {},
}

const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  color: #AD2624;
`
// const TypeButtonGroup = styled(ButtonGroup)`
//   display: flex;
//   font-family: 'Gotham' !important;
// `
// const TypeButton = styled(Button)`
//   width: 100%;
// `
const FooterButton = styled(Button)`
  margin-right: 10px;
  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};
  font-family: 'Gotham' !important;
`
const SearchField = styled(Input)`
  width: 100%;
  padding-left: 35px;
  margin-top: 10px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: 'Gotham' !important;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const CheckboxGroup = styled(Container)`
  height: 300px;
  overflow-y: scroll;
  margin-top: 20px;
  padding: 20px;
  border: 1px solid lightgray;
  border-radius: 5px;
  font-family: 'Gotham' !important;
  font-size: 15px;
`
const TextGroup = styled.div`
  display: flex;
  align-items: center;
  /* margin-top: 5px; */
`
const ClickableText = styled(Label)`
  cursor: pointer;
  text-decoration: underline;
  font-family: Gotham;
  margin: 0px;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/form/add-project-forecast.js